module.exports = __webpack_public_path__ + "img/year-in-glance-banner.b9edc86d.png";